import { Lock, LockOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatDateTimeLocale } from '@/common/utils/date';
import type { Tramite } from '@/types';

interface BloqueoBannerProps {
  tramite: Pick<Tramite, 'bloqueado' | 'bloqueado_motivo' | 'bloqueado_at' | 'bloqueado_por'>;
  /** Si se pasa, se renderiza el botón "Desbloquear" a la derecha. */
  onDesbloquear?: () => void;
  isSubmitting?: boolean;
  className?: string;
}

export function BloqueoBanner({ tramite, onDesbloquear, isSubmitting, className }: BloqueoBannerProps) {
  if (!tramite.bloqueado) return null;

  const auditoriaParts = [
    tramite.bloqueado_por?.name ? `Bloqueó ${tramite.bloqueado_por.name}` : null,
    tramite.bloqueado_at ? formatDateTimeLocale(tramite.bloqueado_at) : null,
  ].filter(Boolean);

  return (
    <div
      className={`flex items-start justify-between gap-3 rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-destructive ${className ?? ''}`}
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1 font-medium">
          <Lock className="h-3.5 w-3.5" /> Escritura bloqueada
        </div>
        {tramite.bloqueado_motivo && (
          <p className="mt-1 whitespace-pre-wrap break-words text-xs">{tramite.bloqueado_motivo}</p>
        )}
        {auditoriaParts.length > 0 && (
          <p className="mt-1 text-xs opacity-80">{auditoriaParts.join(' · ')}</p>
        )}
      </div>
      {onDesbloquear && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="shrink-0"
          disabled={isSubmitting}
          onClick={onDesbloquear}
        >
          <LockOpen className="h-3.5 w-3.5" /> Desbloquear
        </Button>
      )}
    </div>
  );
}

export default BloqueoBanner;
